document.addEventListener("DOMContentLoaded", () => {
  // use event delegation so we don't care when the app injects the button
  document.body.addEventListener("click", (e) => {
    const target = e.target.closest(".cbb-frequently-bought-add-button.button");

    if (target) {
      console.log("Frequently Bought button clicked");

      // reload after 3s
      setTimeout(() => {
        location.reload();
      }, 3000);
    }
  });
});
